import React from 'react';
import Button from '@atlaskit/button';
import ToolTip from '@atlaskit/tooltip';
import EditIcon from '@atlaskit/icon/glyph/edit';
import { MoreActions, useSidebar, useFeatureToggle } from '@css-xp/base';
import { ADVOCATE_ACCESS_TYPE, ADVOCATE_RESOURCE_TYPE, useAdvocateAccessControl } from '@css-xp/ppc-access-control';
import { STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';
import { SIDEBAR } from '../sold-to-address-table';

interface Props {
  transactionAccountId: string;
  name: string;
  onComplete?: (_responsePayload?: any) => void;
  isSoldToAddressArchivalEnabled?: boolean;
  isDuplicateCustomerNameEnabled?: boolean;
}

export const CustomerActions = ({
  transactionAccountId,
  name,
  onComplete,
  isSoldToAddressArchivalEnabled,
  isDuplicateCustomerNameEnabled,
}: Props): JSX.Element => {
  const { openSidebar } = useSidebar();
  const isUpdateActionsEnabled = useAdvocateAccessControl({
    accessType: ADVOCATE_ACCESS_TYPE.UPDATE,
    resource: ADVOCATE_RESOURCE_TYPE.CUSTOMER,
  });
  const [isEnabled] = useFeatureToggle();

  if (!isUpdateActionsEnabled) {
    return <></>;
  }

  const openEditCustomerNameSidebar = () => {
    openSidebar({
      sidebarType: SIDEBAR.EDIT_CUSTOMER_NAME,
      payload: {
        transactionAccountId,
        name,
        onComplete,
        isSoldToAddressArchivalEnabled,
        isDuplicateCustomerNameEnabled,
      },
    });
  };

  const isRedesignFastFollowEnabled = isEnabled(STATSIG_FEATURE_GATES.ENABLE_REDESIGN_FAST_FOLLOW);

  if (isRedesignFastFollowEnabled) {
    return (
      <ToolTip content="Edit name">
        <Button
          appearance="subtle"
          onClick={openEditCustomerNameSidebar}
          iconAfter={<EditIcon label="" size="medium" />}
          aria-label="Edit name"
          testId="edit-customer-name-action-btn"
        />
      </ToolTip>
    );
  }

  const actions = [
    {
      id: 'Edit name',
      content: 'Edit name',
      action: openEditCustomerNameSidebar,
    },
  ];

  return <MoreActions actions={actions} testId="edit-customer-name-action-btn" />;
};
